import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export default function Step0({ onStart }) {
  return (
    <>
      <Box>
        <Typography fontWeight={500} fontSize={20}>
          Find and Replace
        </Typography>
      </Box>
      <Box my={3} display="flex" justifyContent="center">
        <img
          src="/item-lookup.png"
          alt="Find and Replace"
          style={{ maxWidth: "100%", maxHeight: 200, borderRadius: 8 }}
        />
      </Box>
      <Typography
        variant="body1"
        color="textSecondary"
        paragraph
        sx={{ maxWidth: 400, mx: "auto" }}
      >
        I'll help you search for a value and replace it everywhere it appears in your inventory.
      </Typography>
      <Box mt={4} display="flex" justifyContent="flex-end">
        <Button variant="contained" color="primary" onClick={onStart} fullWidth>
          Start
        </Button>
      </Box>
    </>
  );
}
